module.exports = __webpack_public_path__ + "static/media/Item_Weapon_PanzerFaust100M_C.ba82b4c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_PanzerFaust100M_C.png
// module id = 411
// module chunks = 0